import { PlanFamily, PlanStatus, SupportedPlan } from "@src/gql/graphql";

export function translatePlanName(props: {
	plan: SupportedPlan;
	planFamily?: PlanFamily;
	status: PlanStatus;
}) {
	const { plan, status, planFamily } = props;

	if (status === PlanStatus.Expired) {
		return "Expired";
	}

	if (status === PlanStatus.Paused) {
		return "Paused";
	}

	if (status === PlanStatus.InTrial) {
		return "Trial";
	}

	if (status === PlanStatus.TrialEnd) {
		return "Trial Ended";
	}

	if (status === PlanStatus.Active || status === PlanStatus.Cancelled) {
		if (plan === SupportedPlan.ProV2Test) {
			return "Pro Test";
		}

		if (planFamily === PlanFamily.Starter) {
			return "Starter";
		}
		if (planFamily === PlanFamily.Pro) {
			return "PRO";
		}
		if (planFamily === PlanFamily.Team) {
			return "Team";
		}

		switch (plan) {
			case SupportedPlan.ProV2:
				return "PRO";
			case SupportedPlan.Believer:
				return "Believer";
			case SupportedPlan.WhiteboardAi:
				return "Demo";
			default:
				return plan;
		}
	}

	return plan;
}
